<template>
  <v-navigation-drawer v-model="drawer" fixed right>
    <v-list color="primary">
      <v-list-item link>
        <v-list-item-content class="white--text">
          <v-list-item-title class="heading mb-2">
            {{ settings('user').name }}
          </v-list-item-title>
          <v-list-item-subtitle class="white--text">{{ settings('user').mob }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense>
      <v-list-item-group v-model="selectedItem" color="primary">
        <!-- Sidebar Links -->
        <v-list-item v-for="(item, i) in items" :key="i" @click.native="item.action">
          <v-list-item-icon>
            <v-icon v-text="item.icon" class="primary--text"></v-icon>
          </v-list-item-icon>
          <v-list-item-content class="primary--text">
            <v-list-item-title v-html="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Logout -->
        <v-list-item v-if="logoutLoading">
          <v-progress-circular indeterminate color="primary" style="width: 20px; height: 20px"></v-progress-circular>
        </v-list-item>
        <v-list-item v-else @click.native="logout">
          <v-list-item-icon>
            <v-icon v-text="'mdi-login'" class="primary--text"></v-icon>
          </v-list-item-icon>
          <v-list-item-content class="primary--text">
            <v-list-item-title v-text="'خروج از حساب'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'Sidebar',
        props: ['show'],
        watch: {
            drawer: function (val) {
                if (val === false) {
                    this.setSidebar(false);
                }
            },
            show: function (val) {
                this.drawer = val;
            },
        },
        data: function () {
            return {
                drawer: false,
                selectedItem: 0,
                logoutLoading: false,
            };
        },
        computed: {
            items() {
                return [
                    {
                        text: 'صفحه اصلی',
                        icon: 'mdi-home',
                        action: () => this.$router.push("/"),
                    },
                    {
                        text: 'پروفایل کاربری',
                        icon: 'mdi-account',
                        action: () => this.$router.push("/profile"),
                    },
                    {
                        text: 'اعتبار (' + this.$helpers.moneyFormat(this.settings('user').balance) + ')',
                        icon: 'mdi-credit-card',
                        action: () => this.$router.push("/transactions"),
                    },
                    {
                        text: 'مشاوره',
                        icon: 'mdi-comment-processing',
                        action: () => this.$router.push("/consults"),
                    },
                    {
                        text: 'آموزش',
                        icon: 'mdi-school',
                        action: () => this.$router.push("/academy"),
                    },
                    {
                        text: 'سوالات متداول',
                        icon: 'mdi-help-circle',
                        action: () => this.$router.push("/faq"),
                    },
                    {
                        text: 'پشتیبانی',
                        icon: 'mdi-headphones-box',
                        action: () => this.$router.push("/tickets"),
                    },
                    {
                        text: 'درباره ما',
                        icon: 'mdi-comment-text',
                        action: () => this.$router.push("/about"),
                    },
                ];
            },
        },
        methods: {
            ...mapActions('user', ['logoutUser']),
            ...mapActions(['setSidebar']),
            async logout() {
                this.logoutLoading = true;
                await this.logoutUser();
                this.logoutLoading = false;
            }
        }
    };
</script>
<style scoped>
  .v-list-item /deep/ .v-list-item__title {
    font-size: 1rem;
  }

  .v-list-item /deep/ .v-list-item__icon {
    margin: 10px 0 0 20px;
  }

  .v-navigation-drawer {
    z-index: 100;
  }
</style>